import { Link } from "react-router-dom";
import { Clock } from "lucide-react";
import { usePageTitle } from "../hooks/usePageTitle";
import { CALCOM_DEMO_URL } from "../config/demo";

export default function ComingSoonPage({ pageName = "Coming Soon" }) {
  const titleMap = {
    "Blog": "Blog | CleanBid.ai",
    "Contact": "Contact | CleanBid.ai",
    "ROI Calculator": "ROI Calculator | CleanBid.ai",
  };
  usePageTitle(titleMap[pageName] || `${pageName} | CleanBid.ai`);
  return (
    <div className="bg-[#0A0A0F] pt-20 min-h-screen flex items-center justify-center">
      <div className="text-center max-w-md mx-auto px-4">
        <div className="w-14 h-14 rounded-2xl bg-[#111118] border border-[#1E1E2E] flex items-center justify-center mx-auto mb-6">
          <Clock className="w-7 h-7 text-[#71DED6]" />
        </div>
        <h1 className="text-3xl font-bold tracking-tight text-[#F4F4F8] mb-3">{pageName}</h1>
        <p className="text-[#8B8BA7] mb-8 leading-relaxed">
          This page is in progress. Check back soon.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link
            to="/"
            className="text-sm text-[#8B8BA7] hover:text-[#F4F4F8] transition-colors"
          >
            ← Back to home
          </Link>
          <span className="hidden sm:block text-[#1E1E2E]">·</span>
          <a
            href={CALCOM_DEMO_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm text-[#71DED6] hover:underline"
          >
            Book a Demo
          </a>
        </div>
      </div>
    </div>
  );
}
